import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/Result.css";
import backgroundImage from "../assets/home_background.png";
import { LanguageContext } from "../LanguageContext";

const Result = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const probability = state?.score || 0;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div
      className="result-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="result-overlay" />
      <div className="result-content">
        <h2>
          {language === "ko"
            ? "당신의 임신 가능률은..."
            : "The probability of having a baby is..."}
        </h2>
        <div className="result-score">{probability}%</div>
        <button className="retry-button" onClick={() => navigate("/")}>
          {language === "ko" ? "테스트 다시 하기" : "Retake the Test"}
        </button>
      </div>
    </div>
  );
};

export default Result;
